import { gql } from "@apollo/client";
import { WarehouseLocationType } from "../fragments";

const FETCH_WAREHOUSE_LOCATION_TYPES = gql`
  query FetchWarehouseLocationTypes($input: WarehouseLocationTypeListFilter) {
    warehouseLocationTypes(input: $input) {
      ${WarehouseLocationType}
    }
  }
`;

export { FETCH_WAREHOUSE_LOCATION_TYPES };
